<template>
  <form class="form" @submit.prevent="onSubmit()">
    <FormGroup :v="v$.email" :label="null">
      <ToggleField
        id="subscribe_email"
        v-model="formValue.email"
        :disabled="props.disabled"
      >
        {{ $t("subscriptionModal.emailLabel") }}
      </ToggleField>
    </FormGroup>
    <FormGroup :v="v$.sms" :label="null">
      <ToggleField
        id="subscribe_sms"
        v-model="formValue.sms"
        :disabled="props.disabled"
      >
        {{ $t("subscriptionModal.smsLabel") }}
      </ToggleField>
    </FormGroup>

    <FormGroup v-if="isPhoneRequired" :v="v$.phone" label="label.phone">
      <TextField
        v-model="formValue.phone"
        type="text"
        inputmode="phone"
        :disabled="props.disabled"
        placeholder="placeholder.phone"
        autocomplete="phone"
      />
    </FormGroup>

    <FormGroup :v="v$.newsletter" :label="null">
      <ToggleField
        id="subscribe_newsletter"
        v-model="formValue.newsletter"
        :disabled="props.disabled"
      >
        {{ $t("subscriptionModal.newsletterLabel") }}
      </ToggleField>
    </FormGroup>
    <AppButton type="submit" :loading="props.disabled">
      {{ $t("common.save") }}
    </AppButton>
  </form>
</template>

<script setup lang="ts">
import { computed, reactive } from "vue";
import FormGroup from "@/components/form/form-group.vue";
import TextField from "@/components/form/text-field.vue";
import { phone } from "@/utils/validators";
import useVuelidate from "@vuelidate/core";
import AppButton from "@/components/app-button.vue";

import ToggleField from "@/components/form/toggle-field.vue";
import { SubscribeFormData, SubscribeSettings } from "./models";
import { required } from "@vuelidate/validators";

const props = defineProps<{
  disabled?: boolean;
  settings?: SubscribeSettings;
  hasPhone?: boolean;
}>();

const emit = defineEmits<{
  (e: "submit", v: SubscribeFormData): void;
}>();

const formValue = reactive<SubscribeFormData>({
  email: !!props.settings?.reservation_reminder_email,
  sms: !!props.settings?.reservation_reminder_sms,
  newsletter: !!props.settings?.newsletter,
  phone: "",
});

const isPhoneRequired = computed(
  () =>
    !props.settings?.reservation_reminder_sms &&
    !props.hasPhone &&
    formValue.sms
);

const rules = computed(() =>
  isPhoneRequired.value ? { phone: { phone, required } } : {}
);

const v$ = useVuelidate(rules, formValue);

const onSubmit = () => {
  v$.value.$touch();

  if (!v$.value.$invalid) {
    emit("submit", {
      email: formValue.email,
      sms: formValue.sms,
      newsletter: formValue.newsletter,
      phone: isPhoneRequired.value ? formValue.phone : undefined,
    });
  }
};
</script>
